module.exports = __webpack_public_path__ + "313af5a43b5a58c59f2a682ecb78e6cf.pdf";